export default __webpack_public_path__ + "static/five-acres-2a5ef258f5264610c431cfc2ba7e59ac.jpg";